// extracted by mini-css-extract-plugin
module.exports = {"signatureBlock":"SignatureBlock_signatureBlock__3PkZ6","signature":"SignatureBlock_signature__VVfya"};